import React from 'react';
import GrowthGraph from './GrowthGraph';

export default function GrowthGraphByStudentRoute({ match }) {
	const studentId = match.params.student;
	if (studentId == null) return null; // TODO: replace by error

	return <GrowthGraph studentId={studentId} />;
}
